/**
 * Quantity Input Custom Element
 * Handles increment/decrement buttons for quantity selectors
 * and updates the Shopify cart via the Cart API
 */
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="number"]');
    this.minusButton = this.querySelector('button[name="minus"]');
    this.plusButton = this.querySelector('button[name="plus"]');
    this.lineItemKey = this.dataset.line;

    if (this.input && this.minusButton && this.plusButton) {
      this.minusButton.addEventListener('click', this.decrease.bind(this));
      this.plusButton.addEventListener('click', this.increase.bind(this));
      this.input.addEventListener('change', this.onInputChange.bind(this));
    }

    const removeBtn =
      this.parentElement?.querySelector('.cart-item__remove[data-line="' + this.lineItemKey + '"]');
    if (removeBtn && this.lineItemKey) {
      removeBtn.addEventListener('click', this.remove.bind(this));
    }
  }

  remove() {
    this.input.value = 0;
    this.updateCart();
  }

  decrease() {
    const currentValue = parseInt(this.input.value) || 0;
    const min = parseInt(this.input.min) || 0;
    if (currentValue > min) {
      this.input.value = currentValue - 1;
      this.updateCart();
    }
  }

  increase() {
    const currentValue = parseInt(this.input.value) || 0;
    const max = parseInt(this.input.max) || Infinity;
    if (currentValue < max) {
      this.input.value = currentValue + 1;
      this.updateCart();
    }
  }

  onInputChange() {
    this.validate();
    this.updateCart();
  }

  validate() {
    const value = parseInt(this.input.value) || 0;
    const min = parseInt(this.input.min) || 0;
    const max = parseInt(this.input.max) || Infinity;
    
    if (value < min) {
      this.input.value = min;
    } else if (value > max) {
      this.input.value = max;
    }
  }

  async updateCart() {
    if (!this.lineItemKey) return;

    const quantity = parseInt(this.input.value) || 0;
    
    // Disable buttons while updating
    this.classList.add('opacity-50', 'pointer-events-none');

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: this.lineItemKey,
          quantity: quantity
        })
      });

      if (!response.ok) {
        throw new Error('Failed to update cart');
      }

      const cart = await response.json();

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

      window.location.reload();

    } catch (error) {
      console.error('Error updating cart:', error);
      // Optionally reload page on error to reset state
      window.location.reload();
    } finally {
      this.classList.remove('opacity-50', 'pointer-events-none');
    }
  }
}

// Register the custom element
if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', QuantityInput);
}
